import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
import { hasScope } from 'ContentUtils/helpers/scopes';
import Routes from 'ContentUtils/Routes';
import { gate } from 'hub-http/gates';
/**
 * GET designmanager/v1/theme/by-path/{path}/settings
 */
export function fetchThemeSettings(path, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  const themeSettingsPath = Routes.isUngated(gate('ThemesAndModules:ThemeSettingsChirpMigration')) ? 'with-settings' : 'settings';
  return httpClient.get(`designmanager/v1/themes/by-path/${encodeURIComponent(path)}/${themeSettingsPath}`, {
    query: {
      includeBufferedPresetStyles: hasScope('default-theme-presets') || hasScope('branded-theme-presets')
    }
  });
}